
















































































































































import Vue from 'vue';
import MoneyDisplay from '@/components/MoneyDisplay.vue';
import Tabs from "../../../components/Tabs.vue";
import http, { handleApiResponse } from '@/services/http';
import { ColumnType } from '@/components/apiSearch/models/ApiSearch';
import TransactionItem from '../models/TransactionItem';
import InvoiceMirror, {InvoiceMirrorDefaultProps} from '../models/InvoiceMirror';

type TransactionItemDimension = any;

interface Data {
  url: string;
  unfilteredDimensions: TransactionItemDimension[];
  itemInvoiceMirror: InvoiceMirror;
  filteredDimensions: any[];
}

interface Methods {
  preSetItems(e: any): void;
  setItems(e: string, dimCodeType: number): void;
}

interface Computed{
  dim4columns: any[];
  dim5columns: any[];
  dim6columns: any[];
  dim7columns: any[];
  dim8columns: any[];
  dim9columns: any[];
  dim10columns: any[];
  dim11columns: any[];
  dim12columns: any[];
}

interface Props{
  transactionItem: TransactionItem;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    transactionItem: { type: Object as () => TransactionItem}
  },

  components: {
    Tabs,
    MoneyDisplay,
  }, 

  data() {
    return {
      url: "",
      unfilteredDimensions: [],
      itemInvoiceMirror: {...InvoiceMirrorDefaultProps},
      filteredDimensions: [],
    }
  },

  async beforeMount() {
    this.url = `general-ledger-transaction/transactions/items/${this.$props.transactionItem.id}/dimension`;
    const apiSearch = {
      pageSize: 100,
      filter: null,
      extraFilter: null,
      sort: null,
      searchText: "",
    }
    this.unfilteredDimensions = ((await http.post(this.url, apiSearch).then(handleApiResponse)) as any).currentPage;
    this.itemInvoiceMirror = (await http.post("general-ledger-transaction/detail/invoice-mirror/by-account",{year: this.$props.transactionItem.accDate.split("-")[0], accno: this.$props.transactionItem.accNo})).data.data;

    const keys: (keyof InvoiceMirror)[] =  ['dim4', 'dim5', 'dim6', 'dim7', 'dim8', 'dim9', 'dim10', 'dim11', 'dim12'];
    const index = keys.findIndex(key => Number(this.itemInvoiceMirror[key]) != 2);
    (this.$refs.tab as any).setTab((index));
    this.setItems(keys[index],(index+5))
  },

  methods: {
    setItems(e: string, dimCodeType: number) {
      setTimeout(() => {
        this.filteredDimensions = this.unfilteredDimensions.filter((x) => x.dimCodeType == dimCodeType);
      }, 10);
    },

    preSetItems(e: any) {
      this.setItems(e.target.classList[0],Number(e.target.dataset.type));
    }
  },

  computed: {
    dim4columns: () => [
      {
        field: "id",
        title: "Azonosító"
      },
      {
        field: "dimCodeName",
        title: "Dimenzió kód"
      },
      {
        field: "total",
        title: "Összeg",
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim5columns: () => [
      {
        field: "id",
        title: "Azonosító"
      },
      {
        field: "dimCodeName",
        title: "Dimenzió kód"
      },
      {
        field: "extProdParts",
        title: "Cikk ID"
      },
      {
        field: "extProdPartsName",
        title: "Cikkszám"
      },
      {
        field: "total",
        title: "Összeg",
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim6columns: () => [
      {
        field: "id",
        title: "Azonosító"
      },
      {
        field: "dimCodeName",
        title: "Dimenzió kód"
      },
      {
        field: "parts",
        title: "Gyártott termék"
      },
      {
        field: "partsCode",
        title: "Cikkszám"
      },
      {
        field: "partsName",
        title: "Gyári alkatrész"
      },
      {
        field: "stock",
        title: "Készlet ID"
      },
      {
        field: "total",
        title: "Összeg",
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim7columns: () => [
      {
        field: "id",
        title: "Azonosító"
      },
      {
        field: "dimCodeName",
        title: "Dimenzió kód"
      },
      {
        field: "carId",
        title: "Gépjármű"
      },
      {
        field: "regNum",
        title: "Rendszám"
      },
      {
        field: "total",
        title: "Összeg",
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim8columns: () => [
      {
        field: "id",
        title: "Azonosító"
      },
      {
        field: "dimCodeName",
        title: "Dimenzió kód"
      },
      {
        field: "userName",
        title: "Munkatárs"
      },
      {
        field: "stationName",
        title: "Munkaállomás"
      },
      {
        field: "toolName",
        title: "Szerszám"
      },
      {
        field: "total",
        title: "Összeg",
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim9columns: () => [
      {
        field: "id",
        title: "Azonosító"
      },
      {
        field: "dimCodeName",
        title: "Dimenzió kód"
      },
      {
        field: "project",
        title: "Projekt ID"
      },
      {
        field: "projectName",
        title: "Név"
      },
      {
        field: "projectMainCode",
        title: "Belső ID"
      }, 
      {
        field: "projectCode",
        title: "Külső ID"
      },  
      {
        field: "total",
        title: "Összeg",
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim10columns: () => [
      {
        field: "id",
        title: "Azonosító"
      },
      {
        field: "dimCodeName",
        title: "Dimenzió kód"
      },
      {
        field: "extProdPartner",
        title: "Kiegészítő partner ID"
      },
      {
        field: "extProdPartnerName",
        title: "Partner név"
      }, 
      {
        field: "total",
        title: "Összeg",
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim11columns: () =>[
      {
        field: "id",
        title: "Azonosító"
      },
      {
        field: "dimCodeName",
        title: "Dimenzió kód"
      },
      {
        field: "accGroupName",
        title: "Költséghely"
      },
      {
        field: "total",
        title: "Összeg",
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],

    dim12columns: () =>[
      {
        field: "id",
        title: "Azonosító"
      },
      {
        field: "dimCodeName",
        title: "Dimenzió kód"
      },
      {
        field: "projectName",
        title: "Név"
      },
      {
        field: "projectMainCode",
        title: "Belső ID"
      }, 
      {
        field: "projectCode",
        title: "Külső ID"
      },  
      {
        field: "workNumber",
        title: "Munkaszám"
      },
      {
        field: "total",
        title: "Összeg",
        filterable: false,
        cell: "totalTemplate",
        type: ColumnType.Right,
      },
    ],
  },
})
